import React from 'react';

export default function NotFound404() {
  return <h1>Not found</h1>;
}
